import { DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';

import { CUSTOM_BUTTON_SIZE, CustomButton } from 'src/components/CustomButton';
import { CustomDialog } from 'src/components/CustomDialog';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

const BETA_FORM_LINK = 'https://support.anyword.com/kb-tickets/new';

export const UnlockCustomModelPopup = ({ open, onClose }) => {
  const styles = useStyles();

  return (
    <CustomDialog
      className={styles.root}
      open={open}
      onClose={onClose}
      data-testid="BetaIntegrationPopup"
      hideActions
      displayCloseIcon
    >
      <DialogContent className={styles.dialogContent}>
        <CustomTypography
          className={styles.title}
          variant={TYPOGRAPHY_VARIANT.h2}
        >
          Unlock Your Personalized Predictive Model
        </CustomTypography>

        <CustomTypography variant={TYPOGRAPHY_VARIANT.paragraph16}>
          Gain deeper insights with a predictive model fine-tuned for your needs. Contact your
          Customer Success representative to learn more.
        </CustomTypography>

        <CustomButton
          className={styles.button}
          size={CUSTOM_BUTTON_SIZE.large}
          onClick={onClose}
          target="_blank"
          href={BETA_FORM_LINK}
        >
          Contact us
        </CustomButton>
      </DialogContent>
    </CustomDialog>
  );
};

UnlockCustomModelPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
UnlockCustomModelPopup.defaultProps = {};
